<script>
    import {apiRequest} from '../libs/Request.svelte';
    import {dictionary, locale, _} from "svelte-i18n";

    export let language;
    export let facebookAuthEnabled;
    export let googleAuthEnabled;
    export let googleAuthUrl;



    dictionary.set({
        ru: {
            'title': 'Регистрация',
            'description': 'Заполните поля, чтобы получить возможность зарабатывать вместе с нашими офферами.',
            'email': 'email',
            'login': 'логин',
            'password': 'пароль',
            'messenger': 'мессенджер',
            'yourAccount': 'ваш аккаунт',
            'emailPlaceholder': 'Укажите почту',
            'loginPlaceholder': 'Придумайте логин',
            'passwordPlaceholder': 'Придумайте пароль',
            'nicknamePlaceholder': '@nickname',
            'resource': 'Ресурс',
            'resourcePlaceholder': 'Источник трафика',
            'resourceRequiredError': 'Укажите источник трафика',
            'termsAgreementIntro': 'Я прочитал(а) и согласен(на) с условиями',
            'termsAgreement': 'Пользовательского соглашения',
            'iAmAdult': 'Мне есть 18 лет',
            'gdprAccepted': 'Я даю согласие на обработку своих данных',
            'registerButton': 'Зарегистрироваться',
            'loginButton': 'Войти',
            'socialAuthIntro': 'Или зарегистрируйтесь через любимую соц.сеть',
            'notSelected': 'Не выбрано',
            'termsAcceptance': 'Я прочитал(а) и согласен(на) с условиями пользовательского соглашения',
            'termsAcceptanceError': 'Вы должны принять условия пользовательского соглашения',
        },
        en: {
            'title': 'Registration',
            'description': 'Fill the fields to get the opportunity to earn with our offers.',
            'email': 'Email',
            'login': 'Login',
            'password': 'Password',
            'messenger': 'messenger',
            'messengerPlaceholder': 'Not selected',
            'yourAccount': 'your account',
            'emailPlaceholder': 'Enter Email',
            'loginPlaceholder': 'Enter login',
            'passwordPlaceholder': 'Enter password',
            'nicknamePlaceholder': '@nickname',
            'resource': 'Resource',
            'resourcePlaceholder': 'Traffic source',
            'resourceRequiredError': 'Traffic source is required!',
            'termsAgreementIntro': 'I Agree to',
            'termsAgreement': 'Terms',
            'iAmAdult': 'I have 18 years',
            'gdprAccepted': 'I agree to  using my data',
            'registerButton': 'Sign up',
            'loginButton': 'Sign in',
            'socialAuthIntro': 'Sign up via any social network',
            'notSelected': 'Choose one',
            'emailRequiredError': 'Email required!',
            'loginRequiredError': 'Login required!',
            'passwordRequiredError': 'Password cannot be blank!',
            'messengerRequiredError': 'Messenger is required!',
            'messengerAccountRequiredError': 'Messenger account is required!',
            'termsAcceptance': 'I have read and agree to the <a href="">User Agreement</a> and <a href="">Privacy Policy</a>',
            'termsAcceptanceError': 'You have to accept our terms',
            'iAmAdultError': 'You have to be 18+',
        },
    });

    let logoSrc = null;
    switch (language) {
        case 'ru-RU':
            locale.set('ru');
            logoSrc = '/images/zencpa-logo_black.svg';
            break;
        case 'en-US':
        default:
            locale.set('en');
            logoSrc = '/images/fruitcpa-logo_black.svg';
            break;
    }

    let emailError = null;
    let loginError = null;
    let passwordError = null;
    let messengerError = null;
    let messengerAccountError = null;
    let resourceError = null;
    let termsAcceptedError = null;
    let iAmAdultError = null;

    let email = null;
    let login = null;
    let password = null;
    let messenger;
    let messengerAccount = null;
    let resource = '';

    let isSuccessVisible = false;
    let hasError = false;
    let termsAccepted = false;
    let iAmAdult = false;



    function resetErrors() {
        errorMessage = null;
        emailError = null;
        loginError = null;
        passwordError = null;
        messengerError = null;
        messengerAccountError = null;
        resourceError = null;
        termsAcceptedError = null;
        iAmAdultError = null;
    }

    const emailRequiredError = $_('emailRequiredError');
    const loginRequiredError = $_('loginRequiredError');
    const passwordRequiredError = $_('passwordRequiredError');
    const messengerRequiredError = $_('messengerRequiredError');
    const messengerAccountRequiredError = $_('messengerAccountRequiredError');
    const resourceRequiredError = $_('resourceRequiredError');
    const termsAcceptanceRequiredError = $_('termsAcceptanceError');
    const ageRequirementsError = $_('iAmAdultError');
    function checkData() {
        if (!email) {
            emailError = emailRequiredError;
            return false;
        }
        if ( !login) {
            loginError = loginRequiredError;
            return false;
        }
        if (!password) {
            passwordError = passwordRequiredError;
            return false;
        }
        if (!messenger) {
            messengerError = messengerRequiredError;
            return false;
        }
        if (!messengerAccount) {
            messengerAccountError = messengerAccountRequiredError;
            return false;
        }
        if (!resource.trim()) {
            resourceError = resourceRequiredError;
            return false;
        }
        if (!termsAccepted) {
            termsAcceptedError = termsAcceptanceRequiredError;
            return false;
        }
        if (!iAmAdult) {
            iAmAdultError = ageRequirementsError;
            return false;
        }

        return true;
    }

    function prepareData() {
        return {
            email: email,
            username: login,
            password: password,
            messenger: messenger,
            messengerAccount: messengerAccount,
            resource: resource.trim(),
        }
    }

    let errorMessage = null;
    async function handleSubmit(e) {
        resetErrors();
        if (!checkData()) {
            console.log(prepareData());
            return;
        }

        const response = await apiRequest("post", '/auth/ajax-signup', JSON.stringify(prepareData()), {
            'Content-Type': 'application/json',
        })
        isSuccessVisible = (response.status === 'ok');
        if (!isSuccessVisible) {
            errorMessage = response.message;
            return;
        }

        window.location.href = `/auth/login?code=${response.code}`;

        setTimeout(function(){
            isSuccessVisible = false;
        }, 4000);
    }


</script>

<div class="modal-content">
    <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body pb-5 pt-4">
        <div class="row">
            <div class="col-12 offset-0 col-lg-6 offset-lg-3 mb-3">
                <div class="img" style="text-align: center;"><img src={logoSrc} alt=""></div>
            </div>

            <div class="col-12 text-center mb-5">
                <div class="title-wrap h2">{$_('title')}</div>
                <div class="description-wrap">{$_('description')}</div>
            </div>

            <div class="col-12 offset-0 col-lg-6 offset-lg-3">
                <div>
                    <span class="{errorMessage ? '' : 'd-none'}" style="color: red;">
                        <p class="help-block help-block-error">{errorMessage}</p>
                    </span>
                </div>
                <form id="reg-form" class="reg-form" on:submit|preventDefault={handleSubmit}>
                    <div class="modal-fields">
                        <span class="fz-10">{$_('email')}</span>
                        <div class="form-group field-zencparegisterform-mail required">
                            <input type="email"
                                   id="zencparegisterform-mail"
                                   class="form-control py-3 mb-3"
                                   placeholder="{$_('emailPlaceholder')}"
                                   bind:value={email}
                                   required="true" />
                            <span class="{emailError ? '' : 'd-none'}" style="color: red;">
                                <p class="help-block help-block-error">{emailError}</p>
                            </span>
                        </div>
                    </div>
                    <div class="modal-fields">
                        <span class="fz-10">{$_('login')}</span>
                        <div class="form-group field-zencparegisterform-login">
                            <input type="text"
                                   id="zencparegisterform-login"
                                   class="form-control py-3 mb-3"
                                   bind:value={login}
                                   placeholder="{$_('loginPlaceholder')}" />
                            <span class="{loginError ? '' : 'd-none'}" style="color: red;">
                                <p class="help-block help-block-error">{loginError}</p>
                            </span>
                        </div>
                    </div>
                    <div class="modal-fields">
                        <span class="fz-10">{$_('password')}</span>
                        <div class="form-group field-zencparegisterform-password required">
                            <input type="password"
                                   id="zencparegisterform-password"
                                   class="form-control py-3 mb-3"
                                   placeholder="{$_('passwordPlaceholder')}"
                                   bind:value={password}
                                   required="true" />
                            <span class="{passwordError ? '' : 'd-none'}" style="color: red;">
                                <p class="help-block help-block-error">{passwordError}</p>
                            </span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="modal-fields select-block">
                            <span class="fz-10">{$_('messenger')}</span>
                            <div class="form-group field-zencparegisterform-messenger">
                                <select id="zencparegisterform-messenger"
                                        class="form-control py-3 mb-3"
                                        bind:value={messenger}
                                        placeholder="{$_('messengerPlaceholder')}">
                                    <option value="" selected>{$_('notSelected')}</option>
                                    <option value="telegram">Telegram</option>
                                    <option value="whatsapp">WhatsApp</option>
                                    <option value="skype">Skype</option>
                                </select>
                                <span class="{messengerError ? '' : 'd-none'}" style="color: red;">
                                    <p class="help-block help-block-error">{messengerError}</p>
                                </span>
                            </div>
                        </div>
                        <div class="modal-fields">
                            <span class="fz-10">{$_('yourAccount')}</span>
                            <div class="form-group field-zencparegisterform-telegram">
                                <input type="text"
                                       id="zencparegisterform-telegram"
                                       class="form-control py-3 mb-3"
                                       bind:value={messengerAccount}
                                       placeholder="{$_('nicknamePlaceholder')}" />
                                <span class="{messengerAccountError ? '' : 'd-none'}" style="color: red;">
                                    <p class="help-block help-block-error">{messengerAccountError}</p>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-fields">
                        <span class="fz-10" id="resource-label">{$_('resource')}</span>
                        <div class="form-group field-zencparegisterform-resource required">
                            <input type="text"
                                   id="zencparegisterform-resource"
                                   class="form-control py-3 mb-3"
                                   bind:value={resource}
                                   placeholder="{$_('resourcePlaceholder')}"
                                   required
                                   aria-labelledby="resource-label"
                                   aria-invalid={resourceError ? 'true' : 'false'}
                                   aria-describedby="resource-error" />
                            <span class="{resourceError ? '' : 'd-none'}" style="color: red;" id="resource-error">
                                <p class="help-block help-block-error">{resourceError}</p>
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-1">
                            <input type="checkbox" bind:value={termsAccepted} />
                        </div>
                        <div class="col-11">
                            {@html $_('termsAcceptance')}
                            <div class="{termsAcceptedError ? '' : 'd-none'}" style="color: red;">
                                <p class="help-block help-block-error">{termsAcceptedError}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-1">
                            <input type="checkbox" bind:value={iAmAdult} />
                        </div>
                        <div class="col-11">
                            {@html $_('iAmAdult')}
                            <div class="{iAmAdultError ? '' : 'd-none'}" style="color: red;">
                                <p class="help-block help-block-error">{iAmAdultError}</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mt-4 mb-4 justify-content-between">
                        <a href={googleAuthUrl}>
                            {#if language === 'en-US'}
                            <svg width="178" height="50" viewBox="0 0 178 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M33.7188 24.5C33.7188 23.6082 33.9645 22.7728 34.3913 22.0575V19.0232H31.3571C30.1528 20.5872 29.5 22.4934 29.5 24.5C29.5 26.5067 30.1528 28.4128 31.3571 29.9768H34.3913V26.9426C33.9645 26.2272 33.7188 25.3918 33.7188 24.5Z" fill="#FBBD00"/>
                                <path d="M38.5 29.2814L36.3906 31.3908L38.5 33.5002C40.5067 33.5002 42.4128 32.8474 43.9768 31.6431V28.6121H40.9458C40.2242 29.0405 39.3853 29.2814 38.5 29.2814Z" fill="#0F9D58"/>
                                <path d="M34.3912 26.9426L31.3569 29.9769C31.5954 30.2865 31.855 30.5831 32.1359 30.8641C33.8358 32.5639 36.0959 33.5001 38.4999 33.5001V29.2813C36.7553 29.2813 35.2262 28.342 34.3912 26.9426Z" fill="#31AA52"/>
                                <path d="M47.5 24.4998C47.5 23.9523 47.4504 23.4037 47.3526 22.8694L47.2735 22.437H38.5V26.6558H42.7698C42.3552 27.4806 41.7176 28.1535 40.9457 28.6118L43.9768 31.6428C44.2864 31.4044 44.583 31.1448 44.8639 30.8638C46.5638 29.1639 47.5 26.9038 47.5 24.4998Z" fill="#3C79E6"/>
                                <path d="M41.8809 21.1191L42.2537 21.492L45.2369 18.5089L44.864 18.1361C43.1641 16.4362 40.904 15.5 38.5 15.5L36.3906 17.6094L38.5 19.7188C39.7771 19.7188 40.9778 20.2161 41.8809 21.1191Z" fill="#CF2D48"/>
                                <path d="M38.4999 19.7188V15.5C36.0959 15.5 33.8358 16.4362 32.1359 18.136C31.855 18.4169 31.5954 18.7135 31.3569 19.0232L34.3912 22.0574C35.2263 20.6581 36.7553 19.7188 38.4999 19.7188Z" fill="#EB4132"/>
                                <path d="M73.3157 20.2L70.0677 30H68.1357L65.7137 22.748L63.2497 30H61.3037L58.0557 20.2H59.9457L62.3817 27.648L64.9157 20.2H66.5957L69.0737 27.69L71.5797 20.2H73.3157ZM74.6988 22.524H76.4488V30H74.6988V22.524ZM75.5808 21.292C75.2634 21.292 74.9974 21.194 74.7828 20.998C74.5681 20.7927 74.4608 20.5407 74.4608 20.242C74.4608 19.9433 74.5681 19.696 74.7828 19.5C74.9974 19.2947 75.2634 19.192 75.5808 19.192C75.8981 19.192 76.1641 19.29 76.3788 19.486C76.5934 19.6727 76.7008 19.9107 76.7008 20.2C76.7008 20.508 76.5934 20.7693 76.3788 20.984C76.1734 21.1893 75.9074 21.292 75.5808 21.292ZM83.2397 29.594C83.0343 29.762 82.7823 29.888 82.4837 29.972C82.1943 30.056 81.8863 30.098 81.5597 30.098C80.7383 30.098 80.1037 29.8833 79.6557 29.454C79.2077 29.0247 78.9837 28.3993 78.9837 27.578V23.98H77.7517V22.58H78.9837V20.872H80.7337V22.58H82.7357V23.98H80.7337V27.536C80.7337 27.9 80.8223 28.18 80.9997 28.376C81.177 28.5627 81.4337 28.656 81.7697 28.656C82.1617 28.656 82.4883 28.5533 82.7497 28.348L83.2397 29.594ZM88.9213 22.44C89.8639 22.44 90.6199 22.7153 91.1893 23.266C91.7586 23.8167 92.0433 24.6333 92.0433 25.716V30H90.2933V25.94C90.2933 25.2867 90.1393 24.7967 89.8313 24.47C89.5233 24.134 89.0846 23.966 88.5153 23.966C87.8713 23.966 87.3626 24.162 86.9893 24.554C86.6159 24.9367 86.4293 25.492 86.4293 26.22V30H84.6793V19.612H86.4293V23.392C86.7186 23.084 87.0733 22.8507 87.4933 22.692C87.9226 22.524 88.3986 22.44 88.9213 22.44ZM104.992 24.988H106.714V28.894C106.21 29.2953 105.622 29.6033 104.95 29.818C104.278 30.0327 103.588 30.14 102.878 30.14C101.88 30.14 100.979 29.9253 100.176 29.496C99.3737 29.0573 98.7437 28.4553 98.2864 27.69C97.829 26.9247 97.6004 26.0613 97.6004 25.1C97.6004 24.1387 97.829 23.2753 98.2864 22.51C98.7437 21.7447 99.3737 21.1473 100.176 20.718C100.988 20.2793 101.898 20.06 102.906 20.06C103.728 20.06 104.474 20.1953 105.146 20.466C105.818 20.7367 106.383 21.1333 106.84 21.656L105.692 22.776C104.946 22.0293 104.045 21.656 102.99 21.656C102.3 21.656 101.684 21.8007 101.142 22.09C100.61 22.3793 100.19 22.7853 99.8824 23.308C99.5837 23.8307 99.4344 24.428 99.4344 25.1C99.4344 25.7533 99.5837 26.3413 99.8824 26.864C100.19 27.3867 100.61 27.7973 101.142 28.096C101.684 28.3947 102.295 28.544 102.976 28.544C103.742 28.544 104.414 28.376 104.992 28.04V24.988ZM112.307 30.098C111.551 30.098 110.869 29.9347 110.263 29.608C109.656 29.2813 109.18 28.8287 108.835 28.25C108.499 27.662 108.331 26.9993 108.331 26.262C108.331 25.5247 108.499 24.8667 108.835 24.288C109.18 23.7093 109.656 23.2567 110.263 22.93C110.869 22.6033 111.551 22.44 112.307 22.44C113.072 22.44 113.758 22.6033 114.365 22.93C114.971 23.2567 115.443 23.7093 115.779 24.288C116.124 24.8667 116.297 25.5247 116.297 26.262C116.297 26.9993 116.124 27.662 115.779 28.25C115.443 28.8287 114.971 29.2813 114.365 29.608C113.758 29.9347 113.072 30.098 112.307 30.098ZM112.307 28.6C112.951 28.6 113.483 28.3853 113.903 27.956C114.323 27.5267 114.533 26.962 114.533 26.262C114.533 25.562 114.323 24.9973 113.903 24.568C113.483 24.1387 112.951 23.924 112.307 23.924C111.663 23.924 111.131 24.1387 110.711 24.568C110.3 24.9973 110.095 25.562 110.095 26.262C110.095 26.962 110.3 27.5267 110.711 27.956C111.131 28.3853 111.663 28.6 112.307 28.6ZM121.33 30.098C120.574 30.098 119.893 29.9347 119.286 29.608C118.68 29.2813 118.204 28.8287 117.858 28.25C117.522 27.662 117.354 26.9993 117.354 26.262C117.354 25.5247 117.522 24.8667 117.858 24.288C118.204 23.7093 118.68 23.2567 119.286 22.93C119.893 22.6033 120.574 22.44 121.33 22.44C122.096 22.44 122.782 22.6033 123.388 22.93C123.995 23.2567 124.466 23.7093 124.802 24.288C125.148 24.8667 125.32 25.5247 125.32 26.262C125.32 26.9993 125.148 27.662 124.802 28.25C124.466 28.8287 123.995 29.2813 123.388 29.608C122.782 29.9347 122.096 30.098 121.33 30.098ZM121.33 28.6C121.974 28.6 122.506 28.3853 122.926 27.956C123.346 27.5267 123.556 26.962 123.556 26.262C123.556 25.562 123.346 24.9973 122.926 24.568C122.506 24.1387 121.974 23.924 121.33 23.924C120.686 23.924 120.154 24.1387 119.734 24.568C119.324 24.9973 119.118 25.562 119.118 26.262C119.118 26.962 119.324 27.5267 119.734 27.956C120.154 28.3853 120.686 28.6 121.33 28.6ZM134.414 22.524V28.866C134.414 31.498 133.07 32.814 130.382 32.814C129.663 32.814 128.982 32.7207 128.338 32.534C127.694 32.3567 127.162 32.0953 126.742 31.75L127.526 30.434C127.852 30.7047 128.263 30.9193 128.758 31.078C129.262 31.246 129.77 31.33 130.284 31.33C131.105 31.33 131.707 31.1433 132.09 30.77C132.472 30.3967 132.664 29.8273 132.664 29.062V28.67C132.365 28.9967 132.001 29.244 131.572 29.412C131.142 29.58 130.671 29.664 130.158 29.664C129.448 29.664 128.804 29.5147 128.226 29.216C127.656 28.908 127.204 28.4787 126.868 27.928C126.541 27.3773 126.378 26.7473 126.378 26.038C126.378 25.3287 126.541 24.7033 126.868 24.162C127.204 23.6113 127.656 23.1867 128.226 22.888C128.804 22.5893 129.448 22.44 130.158 22.44C130.699 22.44 131.189 22.5287 131.628 22.706C132.076 22.8833 132.449 23.154 132.748 23.518V22.524H134.414ZM130.424 28.18C131.086 28.18 131.628 27.984 132.048 27.592C132.477 27.1907 132.692 26.6727 132.692 26.038C132.692 25.4127 132.477 24.904 132.048 24.512C131.628 24.12 131.086 23.924 130.424 23.924C129.752 23.924 129.201 24.12 128.772 24.512C128.352 24.904 128.142 25.4127 128.142 26.038C128.142 26.6727 128.352 27.1907 128.772 27.592C129.201 27.984 129.752 28.18 130.424 28.18ZM136.714 19.612H138.464V30H136.714V19.612ZM147.789 26.304C147.789 26.4253 147.78 26.598 147.761 26.822H141.895C141.998 27.3727 142.264 27.8113 142.693 28.138C143.132 28.4553 143.673 28.614 144.317 28.614C145.139 28.614 145.815 28.3433 146.347 27.802L147.285 28.88C146.949 29.2813 146.525 29.5847 146.011 29.79C145.498 29.9953 144.919 30.098 144.275 30.098C143.454 30.098 142.731 29.9347 142.105 29.608C141.48 29.2813 140.995 28.8287 140.649 28.25C140.313 27.662 140.145 26.9993 140.145 26.262C140.145 25.534 140.309 24.8807 140.635 24.302C140.971 23.714 141.433 23.2567 142.021 22.93C142.609 22.6033 143.272 22.44 144.009 22.44C144.737 22.44 145.386 22.6033 145.955 22.93C146.534 23.2473 146.982 23.7 147.299 24.288C147.626 24.8667 147.789 25.5387 147.789 26.304ZM144.009 23.84C143.449 23.84 142.973 24.008 142.581 24.344C142.199 24.6707 141.965 25.1093 141.881 25.66H146.123C146.049 25.1187 145.82 24.68 145.437 24.344C145.055 24.008 144.579 23.84 144.009 23.84Z" fill="#3B3E43"/>
                                <rect x="0.5" y="0.5" width="177" height="49" rx="11.5" stroke="#4D89EE"/>
                            </svg>
                            {/if}
                        </a>
                        <button type="submit"
                                class="btn.bak border-rounded btn-blue fw-bolder fw-6 py-3 registration-send"
                                aria-label="button">
                            <span class="white">{$_('registerButton')}</span>
                        </button>
                    </div>
                </form>
                <div class="d-flex justify-content-end">
                <a class="auth fz-13 fw-6" href="#" data-bs-toggle="modal" data-bs-target="#authModal">
                    {$_('loginButton')}
                </a>
            </div>
            </div>

        </div>
    </div>
</div>

<style>
    .border-rounded {
        border-radius: 12px!important;
    }
</style>
